<template>
  <v-chip
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    class="justify-center"
    :label="label"
  >
    <v-icon
      v-if="icon"
      :color="iconColor"
      left
    >
      {{ icon }}
    </v-icon>
    <span class="text-overline font-weight-bold"><slot></slot></span>
  </v-chip>
</template>

<script>
export default {
  props: {
    icon: {
      type: String
    },
    iconColor: {
      type: String,
      default: "primary"
    },
    label: {
      type: Boolean,
      default: true
    }
  }
}
</script>
